import { render, staticRenderFns } from "./EventQuestionPage.vue?vue&type=template&id=4828de96"
import script from "./EventQuestionPage.vue?vue&type=script&lang=js"
export * from "./EventQuestionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports